import React from 'react'
import Typist from 'react-typist';

const TypingAnimation = () => {
    return (
        <Typist className="h3 text-dark">
            <span> You can not climb the ladder of success </span>
                <Typist.Backspace count={41} delay={400} />
            <span> With your hands in your pocket </span>
                     <Typist.Backspace count={32} delay={400} />
            <span>FullStack Web Developer | Software Engineer </span>
        </Typist>
    )
}

export default TypingAnimation
